<div class="white">
	<div class="container">
		<h1 class="main-title mb-4">PËR PROJEKTIN</h1>
		<div class="border"></div>

		<div class="content col-12 mt-5 m">
			<div class="left mr-5">
				<h1 class="main-title mb-3">Problemi</h1>
				<p class="short-paragraph">
					Zbulimi i mashtrimit sigurisht është një problem sfidues, duke pasur
					parasysh larminë e mashtrimeve në raport relativisht të vogël me
					mashtrimet e njohura.
				</p>
			</div>
			<div class="right">
				<img class="pl-5" src="../../../../assets/images/computer.svg" />
			</div>
		</div>
	</div>
</div>
<div class="black">
	<div class="container">
		<div class="content col-12 mt-5 m">
			<div class="leftmt-5">
				<img src="../../../../assets/images/project-lady.svg" />
			</div>
			<div class="right mr-5">
				<h1 class="white-main-title mb-3">Zgjidhja</h1>
				<p class="short-paragraph">
					Ndërsa ndërtojmë skenare të zbulimit, kursimet nga parandalimi i
					mashtrimeve duhet të balancohen me koston e kërkesave mashtruese.
				</p>
			</div>
		</div>
	</div>
</div>
<div class="white">
	<div class="container">
		<div class="content col-12 mt-5 ">
			<div class="left mr-5">
				<h1 class="main-title mb-3">Përmirësimi</h1>
				<p class="short-paragraph">
					Teknikat e mësimit të makinerisë lejojnë përmirësimin e saktësisë
					parashikuese, duke mundësuar azhurimin me skenarë të rinjë më
					kompleks.
				</p>
			</div>
			<div class="right">
				<img class="pl-5" src="../../../../assets/images/cards.svg" />
			</div>
		</div>
	</div>
</div>
